import * as actionTypes from '../constants/actionTypes';

export const updateApplicationSuccess = payload => ({
  type: actionTypes.UPDATE_APPLICATION_SUCCESS,
  payload,
});

export const updateSeasonClassSuccess = payload => ({
  type: actionTypes.UPDATE_SEASON_CLASS_SUCCESS,
  payload,
});

export const persistApplication = () => ({
  type: actionTypes.PERSIST_APPLICATION,
});

export const persistSeasonClass = () => ({
  type: actionTypes.PERSIST_SEASON_CLASS,
});

export const persistUnsupportedSchoolsInterest = () => ({
  type: actionTypes.PERSIST_UNSUPPORTED_SCHOOLS_INTEREST,
});

export const removeResidenceHistory = payload => ({
  type: actionTypes.REMOVE_RESIDENCE_HISTORY,
  payload,
});

export const addResidenceHistory = payload => ({
  type: actionTypes.ADD_RESIDENCE_HISTORY,
  payload,
});

export const updateResidenceHistory = payload => ({
  type: actionTypes.UPDATE_RESIDENCE_HISTORY,
  payload,
});

export const resetResidenceHistory = () => ({ type: actionTypes.RESET_RESIDENCE_HISTORY });

export const persistResidenceHistory = () => ({ type: actionTypes.PERSIST_RESIDENCE_HISTORY });

export const resetCourses = () => ({ type: actionTypes.RESET_COURSES });

export const notifyError = error => ({ type: actionTypes.NOTIFY_ERROR, error });

export const notifyAPIError = error => ({ type: actionTypes.NOTIFY_API_ERROR, error });

export const clearAPIErrors = () => ({ type: actionTypes.CLEAR_API_ERRORS });

export const dismissAPIError = errorId => ({ type: actionTypes.DISMISS_API_ERROR, errorId });

export const addPageData = payload => ({ type: actionTypes.ADD_PAGE_DATA, payload });

export const setLoadingState = isLoading => ({ type: actionTypes.SET_LOADING_STATE, isLoading });

export const queryEligibilityRequest = () => ({ type: actionTypes.QUERY_ELIGIBILITY_REQUEST });

export const queryEligibilitySuccess = payload => ({
  type: actionTypes.QUERY_ELIGIBILITY_SUCCESS,
  payload,
});

export const queryUnpaidTuitionCostInLoanCurrencyError = () => ({
  type: actionTypes.QUERY_UNPAID_TUITION_COST_IN_LOAN_CURRENCY_ERROR,
});

export const queryUnpaidTuitionCostInLoanCurrencyRequest = () => ({
  type: actionTypes.QUERY_UNPAID_TUITION_COST_IN_LOAN_CURRENCY_REQUEST,
});

export const queryUnpaidTuitionCostInLoanCurrencySuccess = payload => ({
  type: actionTypes.QUERY_UNPAID_TUITION_COST_IN_LOAN_CURRENCY_SUCCESS,
  payload,
});

export const queryEligibilityError = () => ({ type: actionTypes.QUERY_ELIGIBILITY_ERROR });

export const queryMinLoanAmountRequest = eligibilityId => ({
  type: actionTypes.QUERY_MIN_LOAN_AMOUNT_REQUEST,
  eligibilityId,
});

export const queryMinLoanAmountSuccess = payload => ({
  type: actionTypes.QUERY_MIN_LOAN_AMOUNT_SUCCESS,
  payload,
});

export const navigateWizard = payload => ({
  type: actionTypes.WIZARD_NAVIGATE,
  payload,
});

export const navigateWizardForward = () => ({
  type: actionTypes.WIZARD_FORWARD,
});

export const navigateWizardBack = () => ({
  type: actionTypes.WIZARD_BACK,
});

export const buildWizardPaths = () => ({
  type: actionTypes.WIZARD_PATHS,
});

export const updateWizardForward = payload => ({
  type: actionTypes.WIZARD_UPDATE_FORWARD,
  payload,
});

export const updateWizardBack = payload => ({
  type: actionTypes.WIZARD_UPDATE_BACK,
  payload,
});

export const updateWizardCurrentPath = payload => ({
  type: actionTypes.WIZARD_UPDATE_PATH,
  payload,
});

export const notifyNavigationChange = path => ({
  type: actionTypes.NAVIGATION_CHANGE,
  path,
});

export const doSignIn = () => ({ type: actionTypes.DO_SIGN_IN });

export const signingIn = () => ({ type: actionTypes.SIGNING_IN });

export const signIn = user => ({
  type: actionTypes.SIGN_IN,
  user,
});

export const tokenRenew = user => ({
  type: actionTypes.TOKEN_RENEW,
  user,
});

export const tokenRenewFailed = () => ({ type: actionTypes.TOKEN_RENEW_FAILED });

export const logOut = () => ({ type: actionTypes.LOG_OUT });

export const addLiability = payload => ({ type: actionTypes.ADD_LIABILITY, payload });

export const removeLiability = payload => ({ type: actionTypes.REMOVE_LIABILITY, payload });

export const persistLiabilities = () => ({ type: actionTypes.PERSIST_LIABILITIES });

export const applicationSubmit = () => ({ type: actionTypes.APPLICATION_SUBMIT });

export const applicationSubmitSuccess = payload => ({
  type: actionTypes.APPLICATION_SUBMIT_SUCCESS,
  payload,
});

export const fetchCapOnLoan = () => ({ type: actionTypes.FETCH_CAP_ON_LOAN });
export const fetchCapOnLoanSuccess = payload => ({
  type: actionTypes.FETCH_CAP_ON_LOAN_SUCCESS,
  payload,
});

export const sendBuilderState = payload => ({ type: actionTypes.BUILDER_SEND, payload });
export const fetchBuilderState = appId => ({ type: actionTypes.BUILDER_FETCH, appId });
export const fetchBuilderSuccess = payload => ({
  type: actionTypes.FETCH_BUILDER_SUCCESS,
  payload,
});
export const persistAll = () => ({ type: 'PERSIST_ALL' });
export const mapServerToUi = () => ({ type: actionTypes.APPLICATION_MAP_SERVER_TO_UI });
export const mergeIntoUi = payload => ({ type: actionTypes.BUILDER_MERGE_INTO_UI, payload });
export const continueLatest = () => ({ type: actionTypes.BUILDER_CONTINUE_LATEST });
export const zendeskLoaded = () => ({ type: actionTypes.ZENDESK_LOADED });
export const zendeskLoginUser = () => ({ type: actionTypes.ZENDESK_LOGIN_USER });

export const fetchEmployersRequest = () => ({ type: actionTypes.FETCH_EMPLOYERS_REQUEST });

export const fetchEmployersSuccess = payload => ({
  type: actionTypes.FETCH_EMPLOYERS_SUCCESS,
  payload,
});

export const restartInPlatform = () => ({
  type: actionTypes.RESTART_IN_PLATFORM,
});

export const trackInHeap = payload => ({
  type: actionTypes.TRACK_IN_HEAP,
  payload,
});

export const notifyAPIAuthenticationError = () => ({
  type: actionTypes.API_AUTHENTICATION_ERROR,
});

export const reportUnrecoverableError = error => ({
  type: actionTypes.UNRECOVERABLE_ERROR,
  error,
});

export const reportIneligibleLoanError = error => ({
  type: actionTypes.INELIGIBLE_LOAN_ERROR,
  error,
});

export const reportRecoverableError = error => ({
  type: actionTypes.RECOVERABLE_ERROR,
  error,
});

export const resetStateObjects = payload => ({
  type: actionTypes.CLEAR_STATE,
  payload,
});
